import axios from "axios";
import URL from "../api";
import {
  GET_INTERESTS_FAIL,
  GET_INTERESTS_REQUEST,
  GET_INTERESTS_SUCCESS,
  GET_PROFILES_FAIL,
  GET_PROFILES_REQUEST,
  GET_PROFILES_SUCCESS,
  GET_PROFILE_FAIL,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  LOGIN_USER_SUCCESS,
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
} from "../types";

export const getProfiles = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_PROFILES_REQUEST });

    const {
      Auth: { user },
    } = getState();
    const config = {
      headers: {
        Authorization: "Bearer " + user?.token,
      },
    };

    const { data } = await axios.get(URL + `/profiles`, config);

    dispatch({ type: GET_PROFILES_SUCCESS, payload: data });

    // localStorage.setItem("user_info", JSON.stringify({...data, authenticated: true}));
  } catch (error) {
    dispatch({
      type: GET_PROFILES_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(error);
  }
};

export const getProfileInfo = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_PROFILE_REQUEST });

    const {
      Auth: { user },
    } = getState();
    const config = {
      headers: {
        Authorization: "Bearer " + user?.token,
      },
    };

    const { data } = await axios.get(URL + `/profiles/${id}/details`, config);

    dispatch({ type: GET_PROFILE_SUCCESS, payload: data });

    localStorage.setItem("profile_info", JSON.stringify({ ...data }));
  } catch (error) {
    dispatch({
      type: GET_PROFILE_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(error);
  }
};

export const updateProfile = (profile) => async (dispatch, getState) => {
  try {
    dispatch({ type: UPDATE_PROFILE_REQUEST });

    const {
      Auth: { user },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user?.token,
      },
    };
    console.log({ profile });
    const { data } = await axios.put(URL + `/profiles/update`, profile, config);

    dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: data });
    dispatch(getProfileInfo(user._id));

    // localStorage.setItem("user_info", JSON.stringify({...data, authenticated: true}));
  } catch (error) {
    dispatch({
      type: UPDATE_PROFILE_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(error);
  }
};

export const getInterests = () => async (dispatch) => {
  try {
    dispatch({ type: GET_INTERESTS_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.get(URL + `/profiles/interests`, config);

    dispatch({ type: GET_INTERESTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_INTERESTS_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(error);
  }
};
